import styled from 'styled-components';
import { device } from 'styles/device';
import { space } from 'shared';

export const Screen = styled.main`
  min-height: 100vh;
  padding: ${space(40)};
  background: ${({ theme }) => theme.loginSurface || theme.grayF7};
  color: ${({ theme }) => theme.textColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.secondary};
  font-size: 36px;
  margin: 0 0 ${space(20)};

  @media ${device.mobile} {
    font-size: 28px;
  }
`;

export const Description = styled.p`
  max-width: 640px;
  font-size: 20px;
  line-height: 1.5;
  margin: 0;
`;

export const Countdown = styled.div`
  color: ${({ theme }) => theme.secondary};
  font-size: 56px;
  font-variant-numeric: tabular-nums;
  font-weight: ${({ theme }) => theme.fontWeightBold};
  letter-spacing: 0.04em;
  margin: ${space(40, 0)};

  @media ${device.mobile} {
    font-size: 38px;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: ${space(16)};
  justify-content: center;

  @media ${device.mobile} {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }
`;
